function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, cohort, cohortCount, description, loadingCohortCount, name, showCreateEntityModal) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['save-cohort-button'] = function(text, theme, className, saveAsNew = false) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("span", (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: theme,
              disabled: $helpers.isSaveDisabled(),
              elref: `saveButton`,
              class: className,
            }),
            "on": {
              click: () => $helpers.saveStagedCohortOnInlineModal(saveAsNew),
            },
            "class": {
              'inline-cohorts-button': true,
              'cohorts-save-button': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (text) + "");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'inline-cohorts-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.isOpen() && showCreateEntityModal) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.buildCreateEntityModalAttrs()),
            "on": {
              cancel: $helpers.closeEntityModal,
              save: $helpers.saveStagedCohortOnCreateModal,
              saveAndShare: $helpers.saveStagedCohortOnCreateModal,
            },
            "props": {
              existingEntityNames: $helpers.getCohortNames(),
            },
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getModalAttributes()),
            "on": {
              change: $helpers.handleModalStateChange
            },
            "class": {
              'inline-cohorts-modal': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("section", {
              "class": {
                'inline-cohorts-modal-scroll-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("section", {
                "class": {
                  'inline-cohorts-modal-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("h2", {
                  "class": {
                    'modal-title': true,
                    'mp-font-size-xl': true,
                    'mp-font-weight-bold': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($helpers.getTitle());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("section", {
                "class": {
                  'inline-cohorts-workspace': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("section", {
                  "class": {
                    'inline-cohorts-builder': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isOpen()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("section", {
                      "class": {
                        'inline-cohorts-name-input': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placeholder: `Add name`,
                          label: `Name`,
                          necessary: `required`,
                          maxlength: 190,
                          'validation-status': $helpers.getCohortNameError() ? `invalid` : ``,
                          'error-message': $helpers.getCohortNameError() || ``,
                        }),
                        "props": {
                          value: name,
                        },
                        "on": {
                          input: $helpers.handleNameInputChange,
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((!$attr(`can-apply-unsaved-cohort`)) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("section", {
                        "class": {
                          'inline-cohorts-description': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'descripton-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Description");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'description-input': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-ya-text-editor", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              text: description,
                              'hide-footer': true,
                              'add-text-placeholder': `+Add Description...`,
                            }),
                            "on": {
                              changedText: $helpers.handleDescriptionInputChange,
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'inline-cohorts-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((!$helpers.isReportBasedCohort()) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohort-builder-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Build Cohort");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(($attr(`show-cohort-count`)) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohort-count': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("·");
                            __jade_nodes = __jade_nodes.concat((loadingCohortCount) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'count-number': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("" + (cohortCount) + " users in cohort");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("section", {
                      "class": {
                        'inline-cohorts-builder-qb-wrapper': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((!$helpers.isReportBasedCohort()) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-cohorts-query-builder", {
                          "on": {
                            cohortUpdated: $helpers.handleCohortUpdated,
                            track: $helpers.trackCohortsBuilderEvent,
                          },
                          "attrs": __vjadeStringifyAttrsIfObj({
                            'track-name': $attr(`track-name`),
                            'cohort': cohort.serialize(),
                            'project-id': $attr(`project-id`),
                            'workspace-id': $attr(`workspace-id`),
                            'show-cohort-count': $attr(`show-cohort-count`),
                            'project-has-cohorts': $attr(`project-has-cohorts`),
                            'data-group-id': $attr(`data-group-id`),
                            'user-id': $attr(`user-id`),
                          }),
                          "props": {
                            context: $helpers.getMPContext(),
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'no-cohort-definition': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohort-count': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((loadingCohortCount) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'count-number': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("" + (cohortCount) + " users in cohort");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohort-not-editable-text': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Cohort definitions created from reports cannot be edited");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohort-vew-link-button': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                icon: `share`,
                              }),
                              "on": {
                                click: $helpers.openCohortViewUser
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("View Cohort Users");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'inline-cohorts-builder-footer': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'left-controls': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(($attr(`can-save`)) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($helpers.isSavingRestricted()) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'upsell-button': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                placement: `right`
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("When you upgrade your plan, cohorts can be created and saved to use across all reports in a project.");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                icon: `share`,
                              }),
                              "on": {
                                click: $helpers.openPricingUpsell
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Upgrade to Save");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : ($attr(`can-apply-unsaved-cohort`)) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['save-cohort-button'].call(this, `Save`, `secondary`, `cohorts-save`));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'right-controls': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          theme: `tertiary`
                        }),
                        "on": {
                          click: $helpers.closeModal
                        },
                        "class": {
                          'inline-cohorts-button': true,
                          'cohorts-cancel-button': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Cancel");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(($attr(`can-apply-unsaved-cohort`)) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            theme: `primary`,
                            disabled: $helpers.isSaveDisabled()
                          }),
                          "on": {
                            click: $helpers.commitCohort
                          },
                          "class": {
                            'inline-cohorts-button': true,
                            'cohorts-apply-button': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(`${$helpers.isNewCohort() ? `Add` : `Update`} ${$attr(`type`)}`);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : ($helpers.isNewCohort()) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['save-cohort-button'].call(this, `Create`, `primary`, `cohorts-new`));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['save-cohort-button'].call(this, `Update`, `primary`, `cohorts-update`));
                          __jade_nodes = __jade_nodes.concat((!$attr(`can-edit`)) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                placement: `top`
                              }),
                            }, [__vjadeSafeCode(`You don't have permission to edit this cohort`)]));;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat((!$helpers.isReportBasedCohort()) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['save-cohort-button'].call(this, `Save as New`, `secondary`, `cohorts-save-as-new`, true));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "cohort" in locals ? locals.cohort : typeof cohort !== "undefined" ? cohort : undefined, "cohortCount" in locals ? locals.cohortCount : typeof cohortCount !== "undefined" ? cohortCount : undefined, "description" in locals ? locals.description : typeof description !== "undefined" ? description : undefined, "loadingCohortCount" in locals ? locals.loadingCohortCount : typeof loadingCohortCount !== "undefined" ? loadingCohortCount : undefined, "name" in locals ? locals.name : typeof name !== "undefined" ? name : undefined, "showCreateEntityModal" in locals ? locals.showCreateEntityModal : typeof showCreateEntityModal !== "undefined" ? showCreateEntityModal : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;